import { render, staticRenderFns } from "./AssetsCollectionConfirm.vue?vue&type=template&id=1757422e&scoped=true&"
import script from "./AssetsCollectionConfirm.vue?vue&type=script&lang=js&"
export * from "./AssetsCollectionConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCollectionConfirm.vue?vue&type=style&index=0&id=1757422e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757422e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardActions,VCardTitle,VCheckbox,VCol,VContainer,VDivider,VForm})
